import { parseUrl } from 'searchband-frontend-commons/util/url';
import { objectToEnumMap, enumPropsFactoryProvider } from './enum-helper';
import { ACTION_TYPE } from '../../const';

export var DIV_ACTION_METHOD = {
    setState: 'set_state'
};

var divActionMethodFactory = enumPropsFactoryProvider(objectToEnumMap(DIV_ACTION_METHOD));

/**
 * Парсер div-action
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-action.json
 * @param  {Object} data.action
 * @return {Object}
 */
export default (function (data) {
    if (!data || !data.action) {
        return null;
    }

    var action = data.action;

    var url = parseUrl(action.url, { validateHostname: false });

    if (!url) {
        return null;
    }

    var logId = action.log_id || '';

    switch (url.protocol()) {
        case ACTION_TYPE.dialog:
            return dialogActionParser(url, logId);
        case ACTION_TYPE.div:
            return divActionParser(url, logId);
        default:
            return {
                url: url.toString(),
                logId: logId,
                type: ACTION_TYPE.uri
            };
    }
});

/**
 * Парсер урла с протоколом dialog-action
 * @param {URI} url
 * @param {String} logId
 * @param {DialogAction}
 */
var dialogActionParser = function dialogActionParser(url, logId) {
    try {
        var directives = JSON.parse(url.query(true).directives);

        if (!directives) {
            return null;
        }

        if (!Array.isArray(directives) || !directives.length) {
            return null;
        }

        return {
            directives: directives,
            logId: logId,
            type: ACTION_TYPE.dialog
        };
    } catch (e) {
        return null;
    }
};

/**
 * Парсер урла с протоколом div-action
 * @param {URI} url
 * @param {String} logId
 * @param {DivAction}
 */
var divActionParser = function divActionParser(url, logId) {
    var method = divActionMethodFactory(url.hostname());

    if (!method) {
        return null;
    }

    var params = url.query(true);

    return {
        method: method,
        params: params,
        logId: logId,
        type: ACTION_TYPE.div
    };
};